import {graphql, useStaticQuery} from 'gatsby';
import * as newsTransformers from '@content/transformers/NewsTransformers';
import {Blog, NewsSettings} from '@content/types/blog';

export interface NewsDataProps {
  allNews: Blog[];
  newsSettings: NewsSettings;
}

const NewsQuery = (): NewsDataProps => {
  const newsData = useStaticQuery(graphql`
    query {
      # api data
      allNodeNews(sort: { fields: created, order: DESC }) {
        edges {
          node {
            langcode
            id
            title
            field_news_reading_time
            field_news_body
            created
            changed
            drupal_internal__nid
            path {
              alias
            }
            status
            field_meta_description
            field_meta_title
            relationships {
              field_news_categories {
                name
              }
              field_news_tags {
                name
              }
              field_news_image {
                uri {
                  url
                }
                localFile {
                  publicURL
                  childImageSharp {
                    fixed(fit: CONTAIN, width: 1095) {
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              field_news_components {
                ... on paragraph__news_cta {
                  id
                  field_nc_button_text
                  field_nc_text
                  field_nc_button_url
                  internal {
                    type
                  }
                }
                ... on paragraph__news_image_title_text {
                  field_nitt_text
                  field_nitt_title
                  id
                  relationships {
                    field_nitt_image {
                      localFile {
                        childImageSharp {
                          fixed(fit: CONTAIN, width: 400) {
                            ...GatsbyImageSharpFixed
                          }
                        }
                      }
                    }
                  }
                  internal {
                    type
                  }
                }
                ... on paragraph__news_quotation {
                  id
                  field_nq_quotation
                  internal {
                    type
                  }
                }
                ... on paragraph__news_text {
                  id
                  field_nt_text
                  internal {
                    type
                  }
                }
                ... on paragraph__video {
                  id
                  field_header
                  field_video_text {
                    value
                  }
                  field_video_video
                  internal {
                    type
                  }
                  relationships {
                    field_thumbnail {
                      localFile {
                        childImageSharp {
                          fixed(fit: CONTAIN, width: 1095) {
                            ...GatsbyImageSharpFixed
                          }
                        }
                      }
                    }
                  }
                }
              }

              field_related_news_1 {
                drupal_id
                field_news_body
                field_news_image {
                  alt
                }
                title
                field_news_reading_time
                created
                relationships {
                  field_news_categories {
                    name
                  }
                  field_news_tags {
                    name
                  }
                  field_news_image {
                    uri {
                      url
                    }
                    localFile {
                      childImageSharp {
                        fixed(fit: CONTAIN, width: 1095) {
                          ...GatsbyImageSharpFixed
                        }
                      }
                    }
                  }
                }
              }
              field_related_news_2 {
                drupal_id
                field_news_body
                field_news_image {
                  alt
                }
                title
                field_news_reading_time
                created
                relationships {
                  field_news_categories {
                    name
                  }
                  field_news_tags {
                    name
                  }
                  field_news_image {
                    uri {
                      url
                    }
                    localFile {
                      childImageSharp {
                        fixed(fit: CONTAIN, width: 1095) {
                          ...GatsbyImageSharpFixed
                        }
                      }
                    }
                  }
                }
              }
              field_related_news_3 {
                drupal_id
                field_news_body
                field_news_image {
                  alt
                }
                title
                field_news_reading_time
                created
                relationships {
                  field_news_categories {
                    name
                  }
                  field_news_tags {
                    name
                  }
                  field_news_image {
                    uri {
                      url
                    }
                    localFile {
                      childImageSharp {
                        fixed(fit: CONTAIN, width: 1095) {
                          ...GatsbyImageSharpFixed
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      allSiteSettingEntityAktualnosci {
        edges {
          node {
            langcode
            field_settings_text_1
            field_settings_text_2
            field_settings_text_3
            field_settings_text_4
            field_settings_text_5
            field_settings_text_6
            field_settings_text_7
            field_settings_button_text
            field_settings_button_text_2
            field_settings_tresc {
              value
            }
            field_meta_description
            field_meta_title
            relationships {
              field_main_image {
                localFile {
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  `);

  return {
    allNews: newsTransformers.transformNews(newsData.allNodeNews),
    newsSettings: newsTransformers.transformNewsSettings(newsData.allSiteSettingEntityAktualnosci),
  };
};

export default NewsQuery;
